import React, { useState } from 'react';
import { Popover } from 'react-tiny-popover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { BrandAttribute } from '../../../../../../../shared/types/brand';

interface AttributeMultiSelectProps {
  attributes: BrandAttribute[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  isMobile: boolean;
  containerRef: React.RefObject<HTMLElement>;
}

export default function AttributeMultiSelect(props: AttributeMultiSelectProps) {
  const { attributes, selectedIds, onChange, isMobile, containerRef } = props;
  const [isOpen, setIsOpen] = useState(false);

  const visibleSelectedCount = selectedIds.filter(id => attributes.some(a => a._id === id)).length;

  function toggle(id: string) {
    onChange(
      selectedIds.includes(id) ? selectedIds.filter(sid => sid !== id) : [...selectedIds, id]
    );
  }

  return (
    // @ts-ignore
    <Popover
      isOpen={isOpen}
      positions={['bottom', 'top']}
      onClickOutside={() => setIsOpen(false)}
      boundaryElement={containerRef.current || undefined}
      parentElement={containerRef.current || undefined}
      containerStyle={{ zIndex: '3' }}
      content={
        <div
          className={
            'w-64 max-h-64 overflow-y-auto bg-white border border-table shadow-lg rounded-lg ' +
            'py-1 go-attribute-multiselect-menu'
          }
        >
          <div
            className={
              'px-3 py-1 cursor-pointer text-sm font-bold text-accent ' +
              'go-attribute-multiselect-clear'
            }
            onClick={() => onChange([])}
          >
            Filter: All
          </div>
          {attributes.map(a => (
            <label
              key={a._id}
              className={
                'flex items-center px-3 py-1 cursor-pointer text-sm ' +
                'go-attribute-multiselect-option'
              }
            >
              <input
                type="checkbox"
                className="mr-2"
                checked={selectedIds.includes(a._id)}
                onChange={() => toggle(a._id)}
              />
              <span className="truncate">{a.name}</span>
            </label>
          ))}
        </div>
      }
    >
      <button
        type="button"
        onClick={() => setIsOpen(prev => !prev)}
        className={
          `text-accent relative${isMobile ? ' grow' : ' w-64'} truncate pl-2 pr-6 py-1 mr-2 ` +
          'border rounded-full border-accent whitespace-nowrap min-w-0 text-left ' +
          'go-event-attribute-select'
        }
      >
        {visibleSelectedCount > 0 ? `${visibleSelectedCount} selected` : 'Filter: All'}
        <FontAwesomeIcon
          icon={faCaretDown}
          className="absolute"
          style={{ top: '50%', right: 10, transform: 'translateY(-50%)' }}
        />
      </button>
    </Popover>
  );
}
